import { Space, Typography } from 'antd';

import { formatDisplayId } from '@/pages/ugc-reports/utils';

type Props = {
    name?: string;
    userId?: string | null;
};

const AuthorNameIdCell: React.FC<Props> = ({ name, userId }) => {
    if (!name && !userId) return <>-</>;

    return (
        <Space direction="vertical" size={4} style={{ width: '100%' }}>
            {name ? (
                <Typography.Text copyable={{ text: name }} style={{ wordBreak: 'break-word' }}>
                    {name}
                </Typography.Text>
            ) : (
                <Typography.Text style={{ wordBreak: 'break-word' }}>-</Typography.Text>
            )}
            {userId ? (
                <Typography.Text copyable={{ text: userId }} type="secondary" style={{ fontSize: 12 }}>
                    {formatDisplayId(userId)}
                </Typography.Text>
            ) : null}
        </Space>
    );
};

export default AuthorNameIdCell;
